/**
 * #1124 : droits des profils côté front.
 *
 * La matrice vient de l'API (crm-api app/helpers/permissions.js), renvoyée au login et à chaque
 * vérification de session, puis gardée dans le store et le localStorage. Le front s'en sert pour
 * afficher menus et boutons ; l'API reste seule juge et refuse ce que le profil ne permet pas.
 *
 * Toujours évaluée pour l'utilisateur effectif : celui qu'un administrateur consulte « en tant
 * que », sinon l'utilisateur connecté.
 */

export function utilisateurEffectif(store) {
  const asUser = store.state.AsUser;
  return asUser && asUser.id_utilisateur !== '' && asUser.id_utilisateur != null ? asUser : store.state.user;
}

function roleDe(user) {
  if (!user) return null;
  if (user.id_role !== undefined && user.id_role !== null) return Number(user.id_role);
  return user.Role ? Number(user.Role.id_role) : null;
}

export function profilDe(store, user) {
  const permissions = store.state.permissions;
  const role = roleDe(user);
  return permissions && role !== null ? permissions.roles[role] || null : null;
}

/** Règle du module pour l'utilisateur effectif ({} si inconnue). */
export function regle(store, module, user = utilisateurEffectif(store)) {
  const permissions = store.state.permissions;
  const profil = profilDe(store, user);
  return (permissions && profil && permissions.matrice[profil][module]) || {};
}

/** 'all' | 'own' | 'none' */
export function portee(store, module, action, user = utilisateurEffectif(store)) {
  return regle(store, module, user)[action] || 'none';
}

/** Droit sur un client : `affecte` = l'utilisateur est affecté à ce client. */
export function peut(store, module, action, affecte = false, user = utilisateurEffectif(store)) {
  const p = portee(store, module, action, user);
  return p === 'all' || (p === 'own' && !!affecte);
}

export function estAdministrateur(store, user = utilisateurEffectif(store)) {
  return profilDe(store, user) === 'administrateur';
}

/** L'utilisateur effectif fait-il partie de cette liste d'ids (commerciaux du client) ? */
export function estAffecte(store, ids) {
  const user = utilisateurEffectif(store);
  return !!user && (ids || []).map(Number).includes(Number(user.id_utilisateur));
}

/** Raccourcis dans les composants : this.$peut('retours', 'ecriture', affecte), etc. */
export default {
  install(Vue) {
    Vue.prototype.$portee = function (module, action) { return portee(this.$store, module, action); };
    Vue.prototype.$peut = function (module, action, affecte) { return peut(this.$store, module, action, affecte); };
    Vue.prototype.$regle = function (module) { return regle(this.$store, module); };
    Vue.prototype.$estAdministrateur = function () { return estAdministrateur(this.$store); };
    Vue.prototype.$estAffecte = function (ids) { return estAffecte(this.$store, ids); };
    Vue.prototype.$utilisateur = function () { return utilisateurEffectif(this.$store); };
    // Administrateur réellement connecté (et non l'utilisateur consulté « en tant que »)
    Vue.prototype.$connecteEstAdministrateur = function () { return estAdministrateur(this.$store, this.$store.state.user); };
  },
};
